import React from 'react';
import styles from './Sidebar.module.scss';
import Contact from '@models/Contact';
import { SharedContact } from '@models/SharedContact';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { startConversation } from '@actions/nexus';
import birthdayIcon from '/img/icons/birthday-no-bg.svg';
import { selectNexusStatus } from '@reducers/data/nexus';

export default function BirthdaySuggestionsBtn({ contact }: { contact: Contact | SharedContact }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const nexusStatus = useSelector(selectNexusStatus);

  const goToBirthdaySuggestions = () => {
    dispatch(
      startConversation(
        `I want to get a gift for my friend ${contact?.displayName}. Can you suggest some gifts they might like?`,
        contact.id,
      ),
    );
    navigate('/nexus', { state: { fromHome: true } });
  };

  if (nexusStatus.needs_permission) {
    return null;
  }

  return (
    <button className={styles.birthdaySuggestionsBtn} onClick={goToBirthdaySuggestions}>
      <img src={birthdayIcon} /> Gift suggestions →
    </button>
  );
}
